import * as angular from 'angular';
import type * as ngRouter from '@uirouter/angularjs';
import { BugsnagService } from '@mode/shared/util-error-handling';

export class RouterLoggingService {
  static $inject = ['$rootScope', '$transitions', 'BugsnagService'];

  constructor(
    private $rootScope: angular.IRootScopeService,
    private $transitions: ngRouter.Transition,
    private bugsnag: BugsnagService
  ) {}

  public init() {
    this.$transitions.onSuccess({}, (trans) => {
      this.logSuccess(trans.to(), trans.params('to'), trans.from(), trans.params('from'));
    });

    this.$transitions.onError({}, (trans) => {
      this.logError(trans.to(), trans.params('to'), trans.from(), trans.params('from'), trans.error());
    });
  }

  private logSuccess(toState, toParams, fromState, fromParams): void {
    this.bugsnag.leaveBreadcrumb(
      '$stateChangeSuccess',
      {
        toRoute: toState.name,
        toParams,
        fromRoute: fromState.name,
        fromParams,
      },
      'state'
    );
  }

  private logError(toState, toParams, fromState, fromParams, error): void {
    let reportingError = error;
    // Sometimes it's an error response object rather than an instance of Error
    if (error) {
      if (error.status) {
        reportingError = new Error(`${error.status}: ${error.statusText} - ${error.xhrStatus}`);
      } else if (error.message) {
        reportingError = new Error(error.message);
      }
    }

    /**
     * Don't log ui-router IGNORED transition errors because these will get fired a lot
     * due not having a sign-in redirect route. When users are automatically shown the sign-in
     * page, the URL will still be the protected route and not the sign-in route, which
     * messes with the router.
     */
    if (error.type !== 5) {
      this.bugsnag.notify(reportingError, (event) => {
        event.errors[0].errorClass = '$stateChangeError';
        event.addMetadata('Transition Info', {
          toRoute: toState.name,
          toParams,
          fromRoute: fromState.name,
          fromParams,
          rawError: error,
        });
      });
    }
  }
}
